import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export enum EGeneralizedSurfaceType {
  TURF = "Turf",
  SYNTHETIC = "Synthetic",
  DIRT = "Dirt"
}

export const getGeneralizedSurface = (distance: number): string => {
  const turfDistance = racehorse360.CourseSurface.COURSE_SURFACE_TURF;
  const syntheticDistances = [
    racehorse360.CourseSurface.COURSE_SURFACE_ALL_WEATHER_TRACK,
    racehorse360.CourseSurface.COURSE_SURFACE_ALL_WEATHER_TRAINING
  ];
  const dirtDistances = [
    racehorse360.CourseSurface.COURSE_SURFACE_WOOD_CHIPS,
    racehorse360.CourseSurface.COURSE_SURFACE_TIMBER,
    racehorse360.CourseSurface.COURSE_SURFACE_DIRT,
    racehorse360.CourseSurface.COURSE_SURFACE_DIRT_TRAINING
  ];

  if (distance === turfDistance) return EGeneralizedSurfaceType.TURF;

  if (syntheticDistances.includes(distance))
    return EGeneralizedSurfaceType.SYNTHETIC;

  if (dirtDistances.includes(distance)) return EGeneralizedSurfaceType.DIRT;

  return "Generalized type isn't determined";
};
